import classnames from 'classnames'
import React, { useState } from 'react'
import { useOutletContext } from 'react-router'
import { Outlet } from 'react-router-dom'
import { CSSTransition } from 'react-transition-group'

import Modal from '../basics/Modal/Modal'
import LoginForm from '../LoginForm/LoginForm'
import { useSession } from '../../state/session'
import SkillfitLogo from '../SkillfitLogo/SkillfitLogo'
import SetPasswordForm from '../userAndGroupForms/SetPasswordForm/SetPasswordForm'

import styles from './LoginGuard.module.scss'

function LoadingScreen({ className }: { className?: string }) {
  return (
    <div className={classnames(styles.LoadingScreen, className)}>
      <SkillfitLogo />
      <div className={styles.loader}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  )
}

export default React.memo(function LoginGuard() {
  const { user, isLoading, isAuthorized, invalidate } = useSession()
  const outletContext = useOutletContext()

  const [key, setKey] = useState(1)

  return (
    <>
      <CSSTransition in={isLoading} timeout={3000} unmountOnExit={true} appear={true}>
        <LoadingScreen />
      </CSSTransition>
      {!isAuthorized && !isLoading && (
        <Modal key={key} className={classnames({ [styles.opague]: !user })} onClose={() => setKey((p) => p + 1)}>
          <LoginForm />
        </Modal>
      )}
      {user?.passwordResetRequired && (
        <Modal key={key} className={classnames({ [styles.opague]: !user })} onClose={() => setKey((p) => p + 1)}>
          <SetPasswordForm emailOrUsername={user.email! || user.username!} onSuccess={invalidate} />
        </Modal>
      )}
      {user && <Outlet context={outletContext} />}
    </>
  )
})
